module.exports = __webpack_public_path__ + "static/media/Card_TwelveWeek_fr.c4dfe2f4.svg";